
















































































import { Vue, Component, Prop } from 'vue-property-decorator';

import BasicMobileFullModal from '~/components/modals/BasicMobileFullModal.vue';
import CheckInput from '~/components/inputs/CheckInput.vue';

@Component({
  components: { BasicMobileFullModal, CheckInput },
})
export default class LocalisationArticlesMobileModal extends Vue {
  @Prop(Array) sports: [];
  @Prop(Array) topicTypes: [];
}
